import { CLASS_ACTIVE, CLASS_INITIALISED } from '../../tools/constants/classes';

const SELECTOR_CONTAINER = '[data-product-comparison-container]';
const SELECTOR_COMPETITOR_ONE = '[data-competitor-one]';
const SELECTOR_COMPETITOR_TWO = '[data-competitor-two]';
const SELECTOR_COMPETITOR_THREE = '[data-competitor-three]';
const SELECTOR_COMPETITOR_FOUR = '[data-competitor-four]';
const SELECTOR_COMPETITOR = '[data-competitor]';
const SELECTOR_DROPDOWN = '[data-competitor-select]';
const SELECTOR_TAB = '[data-comparison-tab]';

const ATTR_TAB_INDEX = 'data-comparison-tab';

document
  .querySelectorAll<HTMLElement>(SELECTOR_CONTAINER)
  .forEach((container) => {
    // Check if section has already been initialized
    if (container.classList.contains(CLASS_INITIALISED)) return;
    container.classList.add(CLASS_INITIALISED);

    const select =
      container.querySelector<HTMLSelectElement>(SELECTOR_DROPDOWN);
    const tabs = container.querySelectorAll<HTMLElement>(SELECTOR_TAB);
    const competitors =
      container.querySelectorAll<HTMLElement>(SELECTOR_COMPETITOR);
    const competitorOnes = container.querySelectorAll<HTMLElement>(
      SELECTOR_COMPETITOR_ONE
    );
    const competitorTwos = container.querySelectorAll<HTMLElement>(
      SELECTOR_COMPETITOR_TWO
    );
    const competitorThrees = container.querySelectorAll<HTMLElement>(
      SELECTOR_COMPETITOR_THREE
    );
    const competitorFours = container.querySelectorAll<HTMLElement>(
      SELECTOR_COMPETITOR_FOUR
    );

    if (
      !select ||
      !tabs ||
      !competitors ||
      !competitorOnes ||
      !competitorTwos ||
      !competitorThrees ||
      !competitorFours
    )
      return;

    /**
     * Hide all competitors lists, then shows the list that matches the value passed in
     * @param selectedCompetitor index number that corresponds to the competitor bullet list to display
     */
    const switchCompetitor = (selectedCompetitor: string) => {
      competitors.forEach((competitor) =>
        competitor.classList.remove(CLASS_ACTIVE)
      );

      switch (selectedCompetitor) {
        case '1':
          competitorOnes.forEach((competitorOne) =>
            competitorOne.classList.add(CLASS_ACTIVE)
          );
          break;
        case '2':
          competitorTwos.forEach((competitorTwo) =>
            competitorTwo.classList.add(CLASS_ACTIVE)
          );
          break;
        case '3':
          competitorThrees.forEach((competitorThree) =>
            competitorThree.classList.add(CLASS_ACTIVE)
          );
          break;
        case '4':
          competitorFours.forEach((competitorFour) =>
            competitorFour.classList.add(CLASS_ACTIVE)
          );
          break;
      }
    };

    // Mobile -- Select listener
    select.addEventListener('change', () => {
      const selectValue = select.value;
      switchCompetitor(selectValue);
    });

    // Desktop -- Tabs Listener
    tabs.forEach((tab) => {
      tab.addEventListener('click', () => {
        const tabIndex = tab.getAttribute(ATTR_TAB_INDEX);

        if (!tabIndex) return;
        switchCompetitor(tabIndex);

        // Remove active class on all tabs
        tabs.forEach((tab) => tab.classList.remove(CLASS_ACTIVE));

        // Add active class to clicked tab
        tab.classList.add(CLASS_ACTIVE);
      });
    });
  });
